(() => {
  const initHeroSlider = (root) => {
    if (root.dataset.heroSliderReady === 'true') return;
    root.dataset.heroSliderReady = 'true';

    const track = root.querySelector('[data-hero-track]');
    const slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
    const previousButton = root.querySelector('[data-hero-prev]');
    const nextButton = root.querySelector('[data-hero-next]');
    const toggleButton = root.querySelector('[data-hero-toggle]');

    if (!track || slides.length < 2) return;

    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const autoplayDelay = Number(root.dataset.autoplay) || 7000;
    let activeIndex = 0;
    let autoplayId = null;
    let userPaused = false;
    let scrollFrame = null;

    const updateActive = (index, shouldScroll = false) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === activeIndex);
        slide.setAttribute('aria-label', `${slideIndex + 1} of ${slides.length}`);
      });
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', String(isActive));
      });

      if (shouldScroll) {
        track.scrollTo({
          left: activeIndex * track.clientWidth,
          behavior: reduceMotionQuery.matches ? 'auto' : 'smooth',
        });
      }
    };

    const stopAutoplay = () => {
      if (autoplayId) window.clearInterval(autoplayId);
      autoplayId = null;
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (userPaused || reduceMotionQuery.matches) return;
      autoplayId = window.setInterval(() => updateActive(activeIndex + 1, true), autoplayDelay);
    };

    const setPaused = (paused) => {
      userPaused = paused;
      if (toggleButton) {
        toggleButton.setAttribute('aria-pressed', String(paused));
        toggleButton.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
      }
      if (paused) stopAutoplay();
      else startAutoplay();
    };

    const syncFromScroll = () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(() => {
        const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        updateActive(index);
        scrollFrame = null;
      });
    };

    previousButton?.addEventListener('click', () => {
      updateActive(activeIndex - 1, true);
      startAutoplay();
    });

    nextButton?.addEventListener('click', () => {
      updateActive(activeIndex + 1, true);
      startAutoplay();
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        updateActive(Number(dot.dataset.index) || 0, true);
        startAutoplay();
      });
    });

    toggleButton?.addEventListener('click', () => setPaused(!userPaused));

    track.addEventListener('scroll', syncFromScroll, { passive: true });
    track.addEventListener('pointerenter', stopAutoplay);
    track.addEventListener('pointerleave', startAutoplay);
    track.addEventListener('focusin', stopAutoplay);
    track.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) startAutoplay();
    });
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        updateActive(activeIndex - 1, true);
        startAutoplay();
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        updateActive(activeIndex + 1, true);
        startAutoplay();
      }
    });

    reduceMotionQuery.addEventListener?.('change', startAutoplay);
    updateActive(0);
    startAutoplay();
  };

  const init = (scope = document) => {
    const roots = [];
    if (scope.matches?.('[data-lecamo-hero-slider]')) roots.push(scope);
    roots.push(...(scope.querySelectorAll?.('[data-lecamo-hero-slider]') || []));
    roots.forEach(initHeroSlider);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
